export const setStorage = data => {
    localStorage.setItem('cache', JSON.stringify(data)); 
}

export const getStorage = () => {
    return JSON.parse(localStorage.getItem('cache'));
}